// WebSocket client. Prefix-agnostic (works behind any proxy path) — lesson
// carried over from STICKRUSH. Remote players are interpolated 120 ms back.
// crypto.randomUUID is missing on older Safari and on plain-http origins
function uuid() {
  try {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  } catch (e) { /* fall through */ }
  let s = '';
  for (let i = 0; i < 32; i++) s += Math.floor(Math.random() * 16).toString(16);
  return s;
}

export class Net {
  constructor() {
    this.ws = null;
    this.id = null;
    this.handlers = new Map();
    this.connected = false;
  }

  on(type, fn) { this.handlers.set(type, fn); return this; }

  connect() {
    const url = new URL('ws', location.href);
    url.protocol = url.protocol.replace('http', 'ws');
    this.ws = new WebSocket(url);
    this.ws.onmessage = ev => {
      let m; try { m = JSON.parse(ev.data); } catch { return; }
      const h = this.handlers.get(m.t);
      if (h) h(m);
    };
    this.ws.onopen = () => {
      this.connected = true;
      // wallet key: an opaque UUID the server only ever uses as a map key.
      // A private window throws on localStorage — fall back to a session UUID.
      let tok = null;
      try {
        tok = localStorage.getItem('ugh3d_token');
        if (!tok) { tok = uuid(); localStorage.setItem('ugh3d_token', tok); }
      } catch (e) { tok = this._sessionTok || (this._sessionTok = uuid()); }
      this.send({ t: 'hello', token: tok });
    };
    this.ws.onclose = () => {
      this.connected = false;
      if (!this.full) setTimeout(() => this.connect(), 2000);
    };
  }

  send(msg) {
    if (this.ws && this.ws.readyState === 1) this.ws.send(JSON.stringify(msg));
  }
}

// Interpolation buffer for one remote player.
export class RemoteBuffer {
  constructor() { this.samples = []; }
  push(s) {
    this.samples.push(s);
    if (this.samples.length > 30) this.samples.shift();
  }
  // returns {p:[x,y,z], yaw, rot} at renderTime (ms, local clock)
  sample(renderTime) {
    const s = this.samples;
    if (!s.length) return null;
    if (s.length === 1 || renderTime <= s[0].at) return s[0];
    for (let i = s.length - 1; i > 0; i--) {
      if (s[i - 1].at <= renderTime && renderTime <= s[i].at) {
        const a = s[i - 1], b = s[i];
        const f = (renderTime - a.at) / Math.max(1, b.at - a.at);
        let dyaw = b.yaw - a.yaw;
        if (dyaw > Math.PI) dyaw -= Math.PI * 2;
        if (dyaw < -Math.PI) dyaw += Math.PI * 2;
        return {
          p: [0, 1, 2].map(k => a.p[k] + (b.p[k] - a.p[k]) * f),
          yaw: a.yaw + dyaw * f,
          rot: a.rot + (b.rot - a.rot) * f,
          carrying: b.carrying,
        };
      }
    }
    return s[s.length - 1];
  }
}
